<div class="iframe-modal">
  <div class="wrapper">
    <div class="header">
      <div class="icons">
        <div
          class="icon close"
          tp="Close window"
          (click)="showCloseModal = true"
        ></div>
      </div>

      <ng-container *ngIf="pageSrcs && pageSrcs.length > 1; else singlePageSrc">
        <div *ngIf="authenticating" class="tabs">
          <div class="tab disabled">Authenticating user...</div>
        </div>
        <div *ngIf="!authenticating" class="tabs">
          <ng-container *ngFor="let pageSrc of pageSrcs; let i = index">
            <div
              class="tab"
              [ngClass]="{
                active: i === selectedPage,
                disabled: !firstIframeLoaded
              }"
              (click)="firstIframeLoaded ? selectPage(i) : null"
            >
              <span>{{
                firstIframeLoaded ? pageSrc.title : 'Loading...'
              }}</span>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-template #singlePageSrc>
        <h4 *ngIf="pageTitle">{{ pageTitle }}</h4>
      </ng-template>

      <div class="right">&nbsp;</div>
    </div>

    <div class="body">
      <div *ngIf="requireAuth && authenticating" class="loading-wrapper">
        <app-shared-loading text="Authenticating..."></app-shared-loading>
      </div>

      <ng-container *ngIf="!authenticating">
        <div class="loading-wrapper">
          <app-shared-loading text="Loading content..."></app-shared-loading>
        </div>
        <ng-container
          *ngIf="!!safePageSrcs && safePageSrcs.length > 1; else singleIframe"
        >
          <iframe
            [src]="safePageSrcs[0]"
            frameborder="0"
            (load)="onFirstIframeLoad()"
            [class.hidden]="0 !== selectedPage"
          ></iframe>
          <ng-container *ngIf="firstIframeLoaded">
            <ng-container
              *ngFor="let src of safePageSrcs.slice(1); let i = index"
            >
              <iframe
                [src]="src"
                [class.hidden]="i + 1 !== selectedPage"
                frameborder="0"
              ></iframe>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-template #singleIframe>
          <iframe [src]="safePageSrc" frameborder="0"></iframe>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>

<app-shared-modal [open]="showCloseModal" name="Close window" [zIndex]="11">
  <div class="close-modal">
    <div>Are you sure you want to close this window?</div>
    <div class="buttons">
      <app-shared-button (click)="closeModal.emit()">Yes</app-shared-button>
      <app-shared-button theme="outline" (click)="showCloseModal = false"
        >No</app-shared-button
      >
    </div>
  </div>
</app-shared-modal>
